export default {
  title: "الصفحة غير موجودة",
  description: `قد تكون الصفحة التي تبحث عنها قد أزيلت أو تم تغيير اسمها
              <br /> أو أنها غير متاحة مؤقتًا.`,
};
